import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { resources } from '../resources';

import ProductsSearchService from '../services/ProductsSearchService';
import { FilterOptionSelectedValueModel } from '../view-models/FamilyOptionModel';

export default class SearchProductsFull extends Vue {
    @Prop(String)
    public searchTerm: string | null = null;

    @Prop(String)
    public languageId: string = "it-IT";

    public searchResponse: any | null = null;

    private searchService: ProductsSearchService | null = null;

    onFetchRequested(pageIndex: number, filters: { [name: string]: FilterOptionSelectedValueModel } | null, orderBy: any[], thisSearchId: number | null,
        pathAndQueryString: string, retrieveFamilyOptions: boolean) {
        var instance = this;

        instance.searchService?.searchProductsFull(instance.searchTerm || '', pageIndex, instance.languageId, filters, orderBy, pathAndQueryString, retrieveFamilyOptions)
            .then((res: any) => {
                res.searchId = thisSearchId;

                // update masterName in products
                for (var i = 0; i < res.results.items.length; i++) {
                    var product = res.results.items[i];

                    let familyName = resources[product.familyCode];

                    if (product.masterName)
                        product.masterName = `${familyName} ${product.masterName}`;
                    else
                        product.masterName = familyName;
                }

                instance.searchResponse = res;
            });
    }

    onHistoryPushed(pathAndQueryString: string) {
        this.searchService?.pushFullSearchHistory(pathAndQueryString, this.languageId);
    }

    created() {
        this.searchService = new ProductsSearchService();
    }
}